(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const init = () => {
      const form = document.querySelector('[data-cart-form]');
      if (!form) return;

      const clamp = (n) => {
        const v = parseInt(n, 10);
        if (isNaN(v) || v < 0) return 0;
        return v;
      };

      form.querySelectorAll('[data-qty]').forEach((qty) => {
        const input = qty.querySelector('[data-qty-input]');
        const down = qty.querySelector('[data-qty-down]');
        const up = qty.querySelector('[data-qty-up]');
        if (!input) return;

        const submit = () => {
          input.value = clamp(input.value);
          form.submit();
        };

        if (down) {
          down.addEventListener('click', () => {
            input.value = Math.max(0, clamp(input.value) - 1);
            submit();
          });
        }
        if (up) {
          up.addEventListener('click', () => {
            input.value = clamp(input.value) + 1;
            submit();
          });
        }
        input.addEventListener('change', submit);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes"] && !Shopify.designMode) return;
  try {
    
  class FinishPicker extends HTMLElement {
    connectedCallback() {
      this.previews = Array.from(this.querySelectorAll('.finish-preview'));
      this.swatches = Array.from(this.querySelectorAll('.finish-swatch'));
      this.swatches.forEach((sw) => {
        sw.addEventListener('click', () => this.activate(sw.dataset.finish));
      });
    }
    activate(id) {
      this.previews.forEach((p) => p.classList.toggle('is-active', p.dataset.finish === id));
      this.swatches.forEach((s) => s.classList.toggle('is-active', s.dataset.finish === id));
    }
  }
  if (!customElements.get('finish-picker')) {
    customElements.define('finish-picker', FinishPicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-locale-open]').forEach(function (trigger) {
    var dialog = document.getElementById(trigger.getAttribute('data-locale-open'));
    if (!dialog) return;

    trigger.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    dialog.querySelectorAll('[data-locale-close]').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Plays the eyes GIF on a <canvas> with random slow-downs and fast-forwards
  // so the eyes appear to blink at irregular, natural-feeling speeds.
  (function () {
    if (typeof window === 'undefined') return;
    if (!('ImageDecoder' in window)) return; // fallback to plain <img>

    const prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const containers = document.querySelectorAll('.header__eyes[data-eyes-src]');

    containers.forEach(async (container) => {
      const canvas = container.querySelector('.header__eyes-canvas');
      const src = container.getAttribute('data-eyes-src');
      if (!canvas || !src) return;

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      let decoder;
      try {
        const response = await fetch(src, { mode: 'cors', credentials: 'omit' });
        if (!response.ok || !response.body) return;
        decoder = new ImageDecoder({
          data: response.body,
          type: 'image/gif',
        });
        await decoder.completed;
      } catch (e) {
        return; // keep <img> fallback visible
      }

      const track = decoder.tracks.selectedTrack;
      const frameCount = track && track.frameCount ? track.frameCount : 0;
      if (!frameCount) return;

      // Pre-decode the first frame to size the canvas to the GIF's native size.
      const first = await decoder.decode({ frameIndex: 0 });
      canvas.width = first.image.displayWidth || first.image.codedWidth;
      canvas.height = first.image.displayHeight || first.image.codedHeight;
      ctx.drawImage(first.image, 0, 0);
      first.image.close();

      container.classList.add('is-animated');

      // The GIF is a single blink (eyes open -> closed -> open). Play those
      // frames fast, then hold on frame 0 (eyes open) for a randomized pause so
      // the eyes rest open for long, irregular stretches between quick blinks.
      const BLINK_SPEED = 3; // >1 = faster than the GIF's native frame timing
      const OPEN_PAUSE_MIN = 1000; // shortest eyes-open hold (ms)
      const OPEN_PAUSE_RANGE = 4000; // additional random hold on top of the min (ms)

      function randomPause() {
        return OPEN_PAUSE_MIN + Math.random() * OPEN_PAUSE_RANGE;
      }

      let frameIndex = 0;
      let cancelled = false;

      // Pause when off-screen / tab hidden to save cycles.
      let visible = true;
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => (visible = e.isIntersecting)),
        { threshold: 0.01 }
      );
      io.observe(container);
      document.addEventListener('visibilitychange', () => {
        visible = !document.hidden && visible;
      });

      async function loop() {
        while (!cancelled) {
          if (!visible) {
            await new Promise((r) => setTimeout(r, 200));
            continue;
          }

          let result;
          try {
            result = await decoder.decode({ frameIndex });
          } catch (e) {
            return;
          }

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(result.image, 0, 0, canvas.width, canvas.height);

          // VideoFrame.duration is in microseconds; fall back to 100ms.
          const baseMs = result.image.duration ? result.image.duration / 1000 : 100;
          result.image.close();

          // Frame 0 is "eyes open": hold it for a randomized rest period.
          // Every other frame plays fast so the blink itself is quick.
          let wait;
          if (frameIndex === 0) {
            wait = randomPause();
          } else {
            wait = Math.max(16, baseMs / BLINK_SPEED);
          }
          await new Promise((r) => setTimeout(r, wait));

          frameIndex = (frameIndex + 1) % frameCount;
        }
      }

      loop();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const sections = document.querySelectorAll('.product-hero');
      if (!sections.length) {
        console.warn('[product-hero] no .product-hero sections found');
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sections.forEach((section) => {
        const canvas = section.querySelector('.product-hero__screen-frame');
        const dataEl = section.querySelector('.product-hero__frames-data');
        if (!canvas) {
          console.warn('[product-hero] missing .product-hero__screen-frame canvas');
          return;
        }
        if (!dataEl) {
          console.warn('[product-hero] missing .product-hero__frames-data');
          return;
        }

        let urls = [];
        try {
          urls = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('[product-hero] failed to parse frames JSON', e, dataEl.textContent);
          return;
        }
        if (!Array.isArray(urls) || urls.length === 0) {
          console.warn('[product-hero] empty frame URL list');
          return;
        }

        urls = urls.filter((u) => typeof u === 'string' && u.length > 0);
        if (urls.length === 0) {
          console.warn('[product-hero] all frame URLs were empty — files probably not uploaded');
          return;
        }

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          console.warn('[product-hero] no 2D canvas context');
          return;
        }

        const images = urls.map(() => null);
        let targetProgress = 0;
        let lastDrawnProgress = -1;
        let rafId = null;
        let sized = false;

        const sizeCanvasTo = (img) => {
          if (sized) return;
          // Match canvas backing-store to the source image so drawImage is 1:1.
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          sized = true;
        };

        const isReady = (i) => {
          const img = images[i];
          return !!(img && img.complete && img.naturalWidth > 0);
        };

        // Find the closest ready frame index to `i`, preferring the requested
        // frame, then falling back outward. Returns -1 if nothing is ready.
        const nearestReady = (i) => {
          if (isReady(i)) return i;
          for (let d = 1; d < urls.length; d++) {
            if (i - d >= 0 && isReady(i - d)) return i - d;
            if (i + d < urls.length && isReady(i + d)) return i + d;
          }
          return -1;
        };

        const drawBlend = (progress) => {
          // Map [0..1] progress to fractional frame index in [0..N-1].
          const exact = progress * (urls.length - 1);
          const lo = Math.floor(exact);
          const hi = Math.min(urls.length - 1, lo + 1);
          const t = exact - lo; // 0..1 blend factor toward `hi`

          const loIdx = nearestReady(lo);
          const hiIdx = nearestReady(hi);
          if (loIdx === -1 && hiIdx === -1) return false;

          // Pick whichever single frame to use as the base.
          const baseIdx = loIdx !== -1 ? loIdx : hiIdx;
          sizeCanvasTo(images[baseIdx]);

          ctx.globalAlpha = 1;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(images[baseIdx], 0, 0, canvas.width, canvas.height);

          if (hiIdx !== -1 && hiIdx !== baseIdx && t > 0) {
            ctx.globalAlpha = t;
            ctx.drawImage(images[hiIdx], 0, 0, canvas.width, canvas.height);
            ctx.globalAlpha = 1;
          }
          return true;
        };

        // Preload + decode every frame.
        urls.forEach((url, i) => {
          const img = new Image();
          img.decoding = 'async';
          img.src = url;
          const onReady = () => {
            images[i] = img;
            // Repaint if this frame is needed at the current scroll position.
            if (lastDrawnProgress < 0 || lastDrawnProgress === targetProgress) {
              if (drawBlend(targetProgress)) lastDrawnProgress = targetProgress;
            }
          };
          if (img.decode) {
            img.decode().then(onReady).catch(() => {
              if (img.complete && img.naturalWidth > 0) onReady();
              else img.addEventListener('load', onReady, { once: true });
            });
          } else {
            img.addEventListener('load', onReady, { once: true });
          }
        });

        console.info('[product-hero] init with', urls.length, 'frames (canvas, crossfade)');

        const setTargetFromScroll = () => {
          const rect = section.getBoundingClientRect();
          // Progress is 0 when the section's top reaches the top of the viewport,
          // and 1 when the section has fully scrolled past.
          const total = rect.height || 1;
          // Reach full progress (last frame) at 1/4 of the section's scroll.
          let progress = (-rect.top / total) / 0.25;
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;
          targetProgress = progress;
        };

        const apply = () => {
          rafId = null;
          // Avoid redundant repaints when scroll position hasn't meaningfully changed.
          if (Math.abs(targetProgress - lastDrawnProgress) < 1 / ((urls.length - 1) * 32)) return;
          if (drawBlend(targetProgress)) {
            lastDrawnProgress = targetProgress;
          }
        };

        const schedule = () => {
          setTargetFromScroll();
          if (rafId) return;
          rafId = requestAnimationFrame(apply);
        };

        if (prefersReducedMotion) {
          return;
        }

        schedule();
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  // Floating buy pill — a second, permanent pill pinned bottom-right. It is
  // simply shown (display) once the hero's pill scrolls past the header and
  // hidden again when the last section (the CTA) reaches the viewport, so the
  // CTA's own pill takes over. No animation: just a display toggle.
  (() => {
    const GAP = 12; // breathing room below the fixed header

    const init = () => {
      const float = document.querySelector('[data-float-buy]');
      if (!float) return;

      const heroPill = document.querySelector('.product-hero__buy');
      const header = document.querySelector('.header');
      const lastSection = document.querySelector('.main-content .shopify-section:last-child');

      let rafId = null;

      const offsetTop = () => {
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        return headerHeight + GAP;
      };

      const apply = () => {
        rafId = null;

        const offset = offsetTop();

        // The hero's in-flow pill has scrolled up past the header.
        const pastHero = heroPill
          ? heroPill.getBoundingClientRect().bottom <= offset
          : window.scrollY > 200;
        // The last section (CTA) has entered the viewport from the bottom.
        const lastReached = lastSection
          ? lastSection.getBoundingClientRect().top <= window.innerHeight
          : false;

        const visible = pastHero && !lastReached;
        float.classList.toggle('is-visible', visible);
        float.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };

      const schedule = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(apply);
      };

      schedule();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rail"] && !Shopify.designMode) return;
  try {
    
  class RailStrip extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.rail) return;

      // Scroll by one item width + the rail's gap so prev/next stays aligned
      // with snap points regardless of viewport size.
      const step = () => {
        const item = this.rail.firstElementChild;
        if (!item) return 480;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap || '18') || 18;
        return item.getBoundingClientRect().width + gap;
      };
      this.prev.addEventListener('click', () => this.rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next.addEventListener('click', () => this.rail.scrollBy({ left: step(), behavior: 'smooth' }));

      this.rail.addEventListener('scroll', () => this.update(), { passive: true });
      // ResizeObserver catches the case where the rail starts wider than its
      // content (no overflow) — both arrows should be disabled.
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.rail);
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    update() {
      const el = this.rail;
      const atStart = el.scrollLeft < 8;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
      this.prev.disabled = atStart;
      this.next.disabled = atEnd;
    }
  }
  if (!customElements.get('rail-strip')) {
    customElements.define('rail-strip', RailStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workflows"] && !Shopify.designMode) return;
  try {
    
  class WorkflowTabs extends HTMLElement {
    connectedCallback() {
      const tabsSlot = this.querySelector('[data-slot="tabs"]');
      const shotsSlot = this.querySelector('[data-slot="shots"]');
      const descsSlot = this.querySelector('[data-slot="descs"]');
      const source = this.querySelector('.workflows__source');
      if (!tabsSlot || !shotsSlot || !descsSlot || !source) return;

      const cards = Array.from(source.querySelectorAll('.workflow-card-parts'));
      cards.forEach((card) => {
        const tab = card.querySelector('.workflow-tab');
        const shot = card.querySelector('.workflow-shot');
        const desc = card.querySelector('.workflow-desc');
        if (tab) tabsSlot.appendChild(tab);
        if (shot) shotsSlot.appendChild(shot);
        if (desc) descsSlot.appendChild(desc);
      });

      this.tabs = Array.from(this.querySelectorAll('.workflow-tab'));
      this.shots = Array.from(this.querySelectorAll('.workflow-shot'));
      this.descs = Array.from(this.querySelectorAll('.workflow-desc'));

      // Ensure at least one is active.
      if (!this.tabs.some((t) => t.classList.contains('is-active')) && this.tabs[0]) {
        this.activate(this.tabs[0].dataset.tab);
      }

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      });
    }
    activate(id) {
      this.shots.forEach((s) => s.classList.toggle('is-active', s.dataset.tab === id));
      this.descs.forEach((d) => d.classList.toggle('is-active', d.dataset.tab === id));
      this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.tab === id));
    }
  }
  if (!customElements.get('workflow-tabs')) {
    customElements.define('workflow-tabs', WorkflowTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
